import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { changePassword } from '../auth';

const TOOLBAR = [
  [{ font: [] }, { size: ['small', false, 'large'] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ color: [] }, { background: [] }],
  [{ align: [] }],
  ['link', 'image'],
  ['clean'],
];

export default function Settings({ signature, onSave, onCancel }) {
  const [sig, setSig] = useState(signature);
  const [curPwd, setCurPwd] = useState('');
  const [newPwd, setNewPwd] = useState('');
  const [pwdMsg, setPwdMsg] = useState('');
  const [pwdError, setPwdError] = useState('');

  async function handleChangePassword(e) {
    e.preventDefault();
    setPwdMsg(''); setPwdError('');
    try {
      await changePassword(curPwd, newPwd);
      setPwdMsg('Password changed successfully');
      setCurPwd(''); setNewPwd('');
    } catch (err) {
      setPwdError(err.response?.data?.error || 'Failed to change password');
    }
  }

  return (
    <div className="settings-panel">
      <div className="settings-header">
        <h2>Settings</h2>
        <button className="compose-close" style={{ color: '#323130' }} onClick={onCancel}>✕</button>
      </div>

      <div className="settings-body">
        <section className="settings-section">
          <h3>Email Signature</h3>
          <p className="settings-hint">Added automatically to new messages and replies. Supports rich text, links and images.</p>

          <div className="signature-quill-wrap">
            <ReactQuill
              theme="snow"
              value={sig}
              onChange={setSig}
              modules={{ toolbar: TOOLBAR }}
              placeholder="e.g. Kind regards, Your Name | FlexiSupport"
            />
          </div>

          <div className="settings-actions">
            <button className="btn-primary" onClick={() => onSave(sig)}>Save signature</button>
            <button className="btn-secondary" onClick={onCancel}>Cancel</button>
            {sig && sig !== '<p><br></p>' && (
              <button className="btn-secondary" onClick={() => setSig('')}>Clear</button>
            )}
          </div>
        </section>

        <hr style={{ border: 'none', borderTop: '1px solid #edebe9', margin: '28px 0' }} />

        <section className="settings-section">
          <h3>Change Password</h3>
          <form onSubmit={handleChangePassword} style={{ maxWidth: 360 }}>
            <div className="login-field">
              <label>Current password</label>
              <input type="password" value={curPwd} onChange={e => setCurPwd(e.target.value)} required />
            </div>
            <div className="login-field">
              <label>New password</label>
              <input type="password" value={newPwd} onChange={e => setNewPwd(e.target.value)} required minLength={6} />
            </div>
            {pwdError && <div className="login-error" style={{ marginBottom: 8 }}>{pwdError}</div>}
            {pwdMsg && <div className="login-success" style={{ marginBottom: 8 }}>{pwdMsg}</div>}
            <button className="btn-primary" type="submit">Change password</button>
          </form>
        </section>
      </div>
    </div>
  );
}
